import { BadgeColor, BadgeSize, ExBadge } from '@boomi/exosphere';
import type { ApprovalTaskStatus } from './sources';

const STATUS_COLOR_MAP = {
    Approved: BadgeColor.GREEN,
    Canceled: BadgeColor.YELLOW,
    Denied: BadgeColor.RED,
    Expired: BadgeColor.GRAY,
    Pending: BadgeColor.BLUE,
} as Record<ApprovalTaskStatus, BadgeColor>;

const getStatusColor = (status: ApprovalTaskStatus | string): BadgeColor => {
    return STATUS_COLOR_MAP[status as ApprovalTaskStatus] || BadgeColor.WHITE;
};

interface TaskStatusBadgeProps {
    status: ApprovalTaskStatus | string;
    size?: BadgeSize;
}

const TaskStatusBadge = ({ status, size = BadgeSize.SMALL }: TaskStatusBadgeProps) => {
    return (
        <ExBadge color={getStatusColor(status)} size={size}>
            {status}
        </ExBadge>
    );
};

export default TaskStatusBadge;
